module.exports = __webpack_public_path__ + "static/9-44f27e027e9ca7fefe485d5f0d52e54e.jpeg";